module.exports = __webpack_public_path__ + "static/media/metro recharge.e3c42979.png";